/**
 * Hook for managing card flipping functionality
 */

import { useState } from 'react';

/**
 * Custom hook for card flipping state and functions
 * @returns {Object} Card flipping state and utility functions
 */
const useCardFlipping = () => {
  const [flippedCards, setFlippedCards] = useState(new Set()); // Flipped card state

  // Utility function to get unique client key
  const getClientKey = (client) => `${client.client_name}-${client.country}`;

  // Card flip functionality
  const isCardFlipped = (client) => {
    return flippedCards.has(getClientKey(client));
  };

  const toggleCardFlip = (client) => {
    const clientKey = getClientKey(client);
    const newFlippedCards = new Set(flippedCards);
    
    if (newFlippedCards.has(clientKey)) {
      newFlippedCards.delete(clientKey);
    } else {
      newFlippedCards.add(clientKey);
    }
    
    setFlippedCards(newFlippedCards);
  };

  return {
    flippedCards,
    isCardFlipped,
    toggleCardFlip,
    setFlippedCards
  };
};

export default useCardFlipping;
